export default "__VITE_PUBLIC_ASSET__e8b5e757__"